import gql from 'graphql-tag';

export const UPDATE_PROPOSAL_MENU_OPTION = gql`
  mutation ($input: UpdateProposalMenuOptionInput) {
    updateProposalMenuOption(input: $input) {
      proposalMenuOptionId
    }
  }
`;
